import { OrganismeStatutType } from '@common/services';

export const ORGANISME_STATUT_TEXTS: Record<OrganismeStatutType, string> = {
  [OrganismeStatutType.ATTENTE_HABILITATION]: 'Habilitation en attente',
  [OrganismeStatutType.CREATION]: 'Création de compte',
  [OrganismeStatutType.MAJ_ANNUELLE]: 'Mise à jour annuelle de compte',
  [OrganismeStatutType.VALIDE]: 'Validé',
  [OrganismeStatutType.DEMANDE_INFORMATION]: 'Demande d\'information',
  [OrganismeStatutType.REFUS]: 'Refusé',
  [OrganismeStatutType.MAJ_DOCUMENTS]: 'Mise à jour des documents',
  [OrganismeStatutType.ATTENTE_REVALIDATION_HABILITATION]: 'Habilitation en attente de revalidation',
  [OrganismeStatutType.DEVALIDE]: 'Dévalidé',
  [OrganismeStatutType.DEPOT_BLOQUE]: 'Dépôt bloqué',
};
